'use client';

import { Button, Tooltip, Chip } from '@mui/material';
import { dateHeader, formatCellDate } from '../../../utils/columns/timeModeCell';
import SettingsIcon from '@mui/icons-material/Settings';
import { ColumnDef } from '@tanstack/react-table';
const makeAdmissionRequestColumn = (handleAdmitUser, handleDeclineUser, handlePermissionsAndRoles) => {
  const columns: ColumnDef<any>[] = [
    {
      header: 'Status',
      accessorKey: 'status',
      enableColumnFilter: false,
      size: 110,
      cell: ({ row }) => {
        if (row.original.status === 999) {
          return (
            <Chip
              label='Pending'
              color='warning'
              size='small'
              style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', fontSize: '11px', margin: 4 }}
            />
          );
        }

        switch (row.original.status) {
          case 0:
            return (
              <Chip
                label='Denied'
                color='error'
                size='small'
                style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', fontSize: '11px', margin: 4 }}
              />
            );
          case 1:
            return (
              <Chip
                label='Approved'
                color='success'
                size='small'
                style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', fontSize: '11px', margin: 4 }}
              />
            );
          case 2:
            return (
              <Chip
                label='Complete'
                color='primary'
                size='small'
                style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', fontSize: '11px', margin: 4 }}
              />
            );
          default:
            return '-';
        }
      },
    },
    {
      header: 'Actions',
      accessorKey: 'actions',
      enableColumnFilter: false,
      size: 200,
      cell: ({ row }) => {
        if (row.original.status === 999) {
          return (
            <div style={{ display: 'flex', gap: '8px' }}>
              <Button
                size='small'
                color='success'
                variant='contained'
                onClick={() => handleAdmitUser(row.original.id)}
                style={{ fontSize: 'x-small', height: 24 }}
              >
                Admit
              </Button>
              <Button
                size='small'
                color='error'
                variant='contained'
                onClick={() => handleDeclineUser(row.original.id)}
                style={{ fontSize: 'x-small', height: 24 }}
              >
                Decline
              </Button>
            </div>
          );
        }

        // Approved status (1)
        if (row.original.status === 1) {
          return (
            <Tooltip title='Configure the users authorization profile'>
              <Button
                size='small'
                variant='outlined'
                onClick={() => handlePermissionsAndRoles(row.original.id, `${row.original.firstName} ${row.original.lastName}`)}
                style={{ fontSize: 'x-small', height: 24, width: '-webkit-fill-available' }}
                startIcon={<SettingsIcon style={{ fontSize: 14 }} />}
              >
                Configure
              </Button>
            </Tooltip>
          );
        }

        // Complete status (2)
        if (row.original.status === 2) {
          return <span style={{ color: 'green', fontWeight: 500 }}>Configuration Completed</span>;
        }

        // Denied status (0)
        if (row.original.status === 0) {
          return (
            <Button size='small' variant='outlined' disabled style={{ fontSize: 'x-small', height: 24, width: '-webkit-fill-available' }}>
              Declined
            </Button>
          );
        }

        return '';
      },
    },
    {
      header: dateHeader('Request date'),
      accessorKey: 'createdDateTime',
      size: 110,
      cell: ({ row, table }) => formatCellDate(table, row.original.createdDateTime),
    },
    {
      header: 'Firstname',
      accessorKey: 'firstName',
      enableColumnFilter: true,
      size: 110,
    },
    {
      header: 'Lastname',
      accessorKey: 'lastName',
      enableColumnFilter: true,
      size: 150,
    },
    {
      header: 'Company',
      accessorKey: 'company',
      enableColumnFilter: true,
      size: 200,
    },
    {
      header: 'Location',
      accessorKey: 'location',
      enableColumnFilter: true,
      size: 200,
    },
    {
      header: 'Email',
      accessorKey: 'email',
      enableColumnFilter: true,
      size: 250,
    },
    {
      header: 'Phone',
      accessorKey: 'phone',
      enableColumnFilter: true,
      size: 110,
    },
    {
      header: 'Customer Type',
      accessorKey: 'customerType',
      enableColumnFilter: true,
      size: 250,
    },
    {
      header: 'Airline affiliation',
      accessorKey: 'airlines',
      enableColumnFilter: true,
      size: 300,
    },
  ];

  return columns;
};

export default makeAdmissionRequestColumn;
